import styles from "./MenuMobile.module.css";
import { Component } from "react";
import { HiMenu, HiX } from "react-icons/hi";
import { motion } from "framer-motion";
import { Link } from "react-scroll";

class MenuMobile extends Component {
  state = { clicou: false };
  clique = () => {
    this.setState({ clicou: !this.state.clicou });
  };
  render() {
    return (
      <div className={this.state.clicou ? styles.menu : styles.menuds}>
        
        <div id={styles.menumobileId} onClick={this.clique}>
          {this.state.clicou ? <HiX /> : <HiMenu />}
        </div>

        {this.state.clicou ? (
          <motion.div className = {styles.mob}  
          initial={{ opacity: 1, y: -1000 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}>

            <ul className={styles.menumob}>
              <li>
                <Link to="inicio" spy={true} smooth={true} offset={-205} duration={50} onClick={this.clique}>
                  Início</Link>
              </li>
              <li>
                <Link to="sobre" spy={true} smooth={true} offset={-130} duration={50} onClick={this.clique}>
                  Sobre</Link>
              </li>
              <li>
                <Link to="equipe" spy={true} smooth={true} offset={-115} duration={50} onClick={this.clique}>
                  Equipe</Link>
              </li>
              <li>
                <Link to="referencias" spy={true} smooth={true} offset={-130} duration={50} onClick={this.clique}>
                  Referencial<br /> teórico</Link>
              </li>
              <li>
                <Link to="resultados" spy={true} smooth={true} offset={-115} duration={50} onClick={this.clique}>
                  Produções</Link>
              </li>
              <li>
                <Link to="contato" spy={true} smooth={true} offset={-130} duration={50} onClick={this.clique}>
                  Contato</Link>
              </li>
            </ul>

          </motion.div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
export default MenuMobile;
